import { RootState } from 'src/config/Store';

export const resourcesToAddSelector = (state: RootState) => state.resources.resourcesToAdd;
